import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyDropDrawer from "@/components/StickyDropDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Drop001 from "@/pages/Drop001";
import ProductDetail from "@/pages/ProductDetail";
import Contraband from "@/pages/Contraband";
import Sizing from "@/pages/Sizing";
import About from "@/pages/About";
import Shipping from "@/pages/Shipping";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import DropManager from "@/pages/admin/DropManager";
import AdminListView from "@/pages/admin/AdminListView";
import AdminPlaceholder from "@/pages/admin/AdminPlaceholder";
import AdminProducts from "@/components/admin/AdminProducts";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <Header />
      <ScrollToTop />
      <main className={isAdmin ? "" : ""}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/drop-001" element={<Drop001 />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/contraband" element={<Contraband />} />
          <Route path="/sizing" element={<Sizing />} />
          <Route path="/about" element={<About />} />
          <Route path="/shipping-returns" element={<Shipping />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="drop-manager" element={<DropManager />} />
            <Route path="drop-list" element={<AdminListView section="drop-list" />} />
            <Route path="notify" element={<AdminListView section="notify" />} />
            <Route path="contraband-access" element={<AdminListView section="contraband" />} />
            <Route path="contacts" element={<AdminListView section="contacts" />} />
            <Route path="orders" element={<AdminPlaceholder label="Orders" />} />
            <Route path="inventory" element={<AdminPlaceholder label="Inventory" />} />
            <Route path="suppliers" element={<AdminPlaceholder label="Suppliers" />} />
            <Route path="customers" element={<AdminPlaceholder label="Customers" />} />
            <Route path="settings" element={<AdminPlaceholder label="Settings" />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      {!isAdmin && <StickyDropDrawer />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
